import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Hive from './components/Hive';
import Cricket from './components/Cricket';
import Projects from './components/Projects';
import Interests from './components/Interests';
import Honors from './components/Honors';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <About />
      <Hive />
      <Cricket />
      <Projects />
      <Interests />
      <Honors />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;

